import script from "./PostsLimit.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostsLimit.vue?vue&type=script&setup=true&lang=ts"

import "./PostsLimit.vue?vue&type=style&index=0&id=0d8a65e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8a65e4"]])

export default __exports__